import React from "react";
import { Col, DropdownItem, DropdownMenu, Row } from "reactstrap";
import styles from "./pageHeader.module.scss"; // Create a new SCSS file for the header styles
import Textfield from "../../components/Shared/Textfield";
import Filterdropdown from "../../components/LocationList/Filterdropdown";

const PageHeader = ({
  title,
  sortOptions,
  onSearch,
  onSort,
  onAdd,
  addButtonLabel,
  SortIcon,
  DropdownIcon,
}) => {
  return (
    <div className={styles["header_wrapper"]}>
      <p className={styles["header_heading"]}>{title}</p>
      <Row className={styles["header"]}>
        <Col xs={12} className={styles["filters_div"]}>
          <Textfield
            className={`${styles["search_textfield"]}`}
            placeholder="Search"
            onChange={onSearch}
          />
          <div>
            <Filterdropdown
              SortIcon={SortIcon}
              toggleIcon={DropdownIcon}
              text="Sort"
              dropdownItems={
                <DropdownMenu className={styles["dropdown_menu"]}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    {sortOptions.map((option, index) => (
                      <DropdownItem
                        className={styles["dropdown_item"]}
                        key={index}
                        onClick={() => onSort(option)}
                      >
                        {option}
                      </DropdownItem>
                    ))}
                  </div>
                </DropdownMenu>
              }
            />
          </div>

          <button className={styles["add_button"]} onClick={onAdd}>
            <div className={styles["add_icon_container"]}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M6 12H18"
                  stroke="#2310F8"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 18V6"
                  stroke="#2310F8"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {addButtonLabel}
            </div>
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default PageHeader;
